import axios from "axios";
import { Toast } from "../../util/Toast";
import {
    GET_OUT_OF_COUNTRY_USER_SETTING,
    UPDATE_ACCESS_CODE,
    TOGGLE_ACCESS_CODE
} from "./types";

export const getOutOfCountryUserSetting = () => (dispatch) => {
    axios
        .get(`outOfCountryUser/setting`)
        .then((res) => {
            if (res.data.status) {
                dispatch({ type: GET_OUT_OF_COUNTRY_USER_SETTING, payload: res.data.data });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};

export const updateAccessCode = (accessCode) => (dispatch) => {
    axios
        .put(`outOfCountryUser/setting/accessCode`, { accessCode })
        .then((res) => {
            if (res.data.status) {
                dispatch({
                    type: UPDATE_ACCESS_CODE,
                    payload: res.data.data
                });
                Toast("success", res.data.message);
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};

export const toggleAccessCode = () => (dispatch) => {
    axios
        .put(`outOfCountryUser/setting/toggleAccess`)
        .then((res) => {
            if (res.data.status) {
                dispatch({
                    type: TOGGLE_ACCESS_CODE,
                    payload: res.data.data
                });
                Toast("success", res.data.message);
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};
